import gql from "graphql-tag";

export const REVIEW_VOTE_CREATE = gql`
  mutation reviewVoteCreate($input: VoteCreateInput!) {
    reviewVoteCreate(input: $input) {
      errors {
        field
        message
      }
      vote {
        id
      }
    }
  }
`;

export const REVIEWS = gql`
  query reviews(
    $product: ID!, $rating: Int, $hasImage: Boolean,
    $sortBy: ReviewOrder, $before:String, $after: String,
    $first: Int, $last: Int
  ) {
    reviews(
      product: $product, rating: $rating, hasImage: $hasImage,
      sortBy: $sortBy, before: $before, after: $after,
      first: $first, last: $last
    ) {
      totalCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          reviewer {
            email
          }
          reviewerName
          rating
          title
          comment
          createdAt
          totalVotes
          hasImage
          images {
            url(size: 200)
          }
          detailImages: images {
            url(size: 540)
          }
          variant {
            id
            name
            attributes {
              value {
                id
                name
                image {
                  alt
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`;
